'use client';

import { AppointmentsContent } from './_components/appointments-content.component';

import { ContentContainer } from '@/components/ui/content-container.component';
import { FeatureGuard } from '@/feature-flags';
import { PageLoadingFallback } from '@/components/ui/page-loading-fallback.component';

export default function MyAppointmentsPage() {
  return (
    <FeatureGuard
      feature="newAppointments"
      fallback={<PageLoadingFallback />}
      showFallbackDuringLoading
    >
      <section className="w-full min-h-full bg-gray-50 py-6">
        <ContentContainer className="flex flex-col items-center gap-6">
          <AppointmentsContent />
        </ContentContainer>
      </section>
    </FeatureGuard>
  );
}
